interface ChatChannelMessageAuthor {
    id: string;
    name: string;
}

interface ChatChannelMessageAttachment {
    type: string;
}

interface ChatChannelMessageInterface {
    id: string;
    author: ChatChannelMessageAuthor;
    text: string;
    attachments: ChatChannelMessageAttachment[];
    date: Date;
    isCurrentUser?: boolean;
    type?: string;
}

export class ChatChannelMessage implements ChatChannelMessageInterface {
    id: string;
    author: ChatChannelMessageAuthor;
    text: string;
    attachments: ChatChannelMessageAttachment[];
    date: Date;
    isCurrentUser: boolean;
    type?: string;

    constructor(data: ChatChannelMessageInterface) {
        this.id = data.id;
        this.author = data.author;
        this.text = data.text;
        this.attachments = data.attachments;
        this.date = data.date;
        this.isCurrentUser = data.isCurrentUser || false;
        this.type = data.type;
    }
}